import React from "react";
import BreadcrumbList from './BreadcrumbList'
import styles from './bottom_styles.css'

export default class BottomBreadcrumb extends React.Component {

  static defaultProps = {
    labels: [],
    isMobile: false,
    className: ''
  };

  constructor(props){
    super(props);

    this.state = {
      isMobile: props.isMobile
    };
  }

  onWindowResize = () => {
    let isMobile = $(window).width() < 768;

    if(isMobile != this.state.isMobile){
      this.setState({isMobile})
    }
  };

  componentDidMount() {
    this.onWindowResize();

    if(window && window.addEventListener) {
      window.addEventListener('resize', this.onWindowResize)
    }
  }

  render() {
    const labels = this.state.isMobile ? this.props.labels : [];
    const trackingProps = {
      "data-user-decision-area": "bottom breadcrumb"
    };

    return <nav className={`${styles['breadcrumb-container-bottom']} ${styles[this.props.className]}`} aria-label="breadcrumbs">
             <BreadcrumbList labels={labels} trackingProps={trackingProps}/>
           </nav>
  }
}
